var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.to)?_c('router-link',{staticClass:"link",attrs:{"to":_vm.to}},[_vm._t("default")],2):(_vm.href)?_c('a',{staticClass:"link",attrs:{"href":_vm.href}},[_vm._t("default")],2):_c('a',{staticClass:"link",on:{"click":_vm.click}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-163f5640","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/parts/components/link.vue
// module id = null
// module chunks = 